import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import ListHackathon from '@/components/admin/hackathon/ListHackathon';
import HeadTitle from '@/components/ui/custom/HeadTitle';
import Layout from '@/components/template/Layout';
import useAuth from '@/data/hook/useAuth';
import NoAdminScreenForMobile from '../NoAdminScreenForMobile';
import AddHackathon from '@/components/admin/hackathon/AddHackathon';
import PageTitle from '@/components/ui/custom/PageTitle';
import AdminButton from '@/components/ui/custom/AdminButton';

export default function ManageHackathon() {
  const { t } = useTranslation('translation', { keyPrefix: 'manageHackathon' });
  const { actionId } = useParams();
  const [isAddHackathon, setIsAddHackathon] = useState(actionId === 'add');

  const { user } = useAuth();

  if (!user) return null;

  return (
    <React.Fragment>
      <HeadTitle routeInfo={t('title')} />
      <div className="md:hidden">
        <NoAdminScreenForMobile />
      </div>
      <div className="hidden md:block w-full">
        <Layout className="gap-2 flex flex-col">
          <PageTitle
            headingText={t('title')}
            position="mb-2"
            backButton={true}
          />
          <AdminButton
            title={t('add')}
            onClick={() => setIsAddHackathon(!isAddHackathon)}
            open={isAddHackathon}
          />
          <AddHackathon show={isAddHackathon} setShow={setIsAddHackathon} />
          <ListHackathon />
        </Layout>
      </div>
    </React.Fragment>
  );
}
